// pages/alarm/BatteryWarning.js —— 报警中心 · 电池预警（doc01 2.11）
// 列表：省 / 市 / 区 + 站点名称 + 预警状态筛选；行内「查看详情」进入电池预警详情页。
import React, { useMemo, useState } from 'react';
import { Table, Tag, Button, Select, Input, Space, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import PageHead from '../../components/PageHead';
import { getBatteryWarnRows, STATION_REGIONS } from '../../config/stationData';

const STATE_COLOR = { 正常: 'green', 关注: 'orange', 异常: 'red' };

// 省 / 市 / 区选项由站点行政区划自动解析（doc 78）
const UNIQUE = (pick) => Array.from(new Set(Object.values(STATION_REGIONS).map(pick)));
const PROVINCE_OPTIONS = [{ value: 'all', label: '全部省' }, ...UNIQUE((r) => r.province).map((v) => ({ value: v, label: v }))];
const CITY_OPTIONS = [{ value: 'all', label: '全部市' }, ...UNIQUE((r) => r.city).map((v) => ({ value: v, label: v }))];
const DISTRICT_OPTIONS = [{ value: 'all', label: '全部区' }, ...UNIQUE((r) => r.district).map((v) => ({ value: v, label: v }))];
const STATE_OPTIONS = [{ value: 'all', label: '全部状态' }, { value: '正常', label: '正常' }, { value: '关注', label: '关注' }, { value: '异常', label: '异常' }];

const ROWS = getBatteryWarnRows();

const BatteryWarning = () => {
  const navigate = useNavigate();
  const [draft, setDraft] = useState({ province: 'all', city: 'all', district: 'all', keyword: '', state: 'all' });
  const [applied, setApplied] = useState(draft);

  const rows = useMemo(() => ROWS.filter((r) => {
    const g = STATION_REGIONS[r.key] || {};
    if (applied.province !== 'all' && g.province !== applied.province) return false;
    if (applied.city !== 'all' && g.city !== applied.city) return false;
    if (applied.district !== 'all' && g.district !== applied.district) return false;
    if (applied.state !== 'all' && r.state !== applied.state) return false;
    if (applied.keyword && !r.name.includes(applied.keyword)) return false;
    return true;
  }), [applied]);

  return (
    <div>
      <PageHead title="电池预警" desc="电池健康与异常预警，提前发现电池风险" />

      <div className="panel">
        <Space wrap style={{ marginBottom: 16 }}>
          <span className="filter-label">省</span>
          <Select value={draft.province} onChange={(v) => setDraft((d) => ({ ...d, province: v }))} style={{ width: 130 }} options={PROVINCE_OPTIONS} />
          <span className="filter-label">市</span>
          <Select value={draft.city} onChange={(v) => setDraft((d) => ({ ...d, city: v }))} style={{ width: 130 }} options={CITY_OPTIONS} />
          <span className="filter-label">区</span>
          <Select value={draft.district} onChange={(v) => setDraft((d) => ({ ...d, district: v }))} style={{ width: 140 }} options={DISTRICT_OPTIONS} />
          <span className="filter-label">预警状态</span>
          <Select value={draft.state} onChange={(v) => setDraft((d) => ({ ...d, state: v }))} style={{ width: 130 }} options={STATE_OPTIONS} />
          <Input
            value={draft.keyword}
            onChange={(e) => setDraft((d) => ({ ...d, keyword: e.target.value }))}
            prefix={<SearchOutlined />}
            placeholder="站点名称"
            style={{ width: 180 }}
            allowClear
          />
          <Button type="primary" onClick={() => { setApplied(draft); message.success('已按条件查询'); }}>查询</Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => { const blank = { province: 'all', city: 'all', district: 'all', keyword: '', state: 'all' }; setDraft(blank); setApplied(blank); message.success('筛选条件已重置'); }}
          >
            重置
          </Button>
        </Space>

        <Table
          rowKey="key"
          dataSource={rows}
          size="middle"
          scroll={{ x: 1180 }}
          pagination={{ pageSize: 10 }}
          columns={[
            { title: '站点名称', dataIndex: 'name', strong: true, width: 180 },
            { title: '装机功率 / 容量', dataIndex: 'power', width: 180 },
            { title: '投运日期', dataIndex: 'onlineAt', width: 130 },
            { title: '电站地址', dataIndex: 'address', width: 260 },
            { title: '最新诊断时间', dataIndex: 'diagAt', width: 170 },
            { title: '预警状态', dataIndex: 'state', width: 110, render: (v) => <Tag color={STATE_COLOR[v]}>{v}</Tag> },
            {
              title: '操作', key: 'action', width: 110, fixed: 'right',
              render: (_, r) => <Button type="link" className="blk-row-btn" size="small" onClick={() => navigate(`/app/alarm/battery/${r.key}`)}>查看详情</Button>,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default BatteryWarning;
